import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { environment } from 'src/environments/environment';
import { UserData } from './Dtos/user-data.entity';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private user$ = new BehaviorSubject<UserData>(null);

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private oktaService: OktaService) {
    this.onUserInfo();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private onUserInfo(): void {
    this.oktaService
      .onNewUserInfo()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((user) => {
        if (user) {
          this.newUser(new UserData(user));
        }
      });
  }

  // ********************************************************************************************************
  // BROADCAST DATA
  // ********************************************************************************************************

  private newUser(user: UserData) {
    this.user$.next(user);
  }

  onNewUser(): Observable<UserData> {
    return this.user$.asObservable();
  }

  getUser(): UserData {
    return this.user$.getValue();
  }

  fullName() : string {
    return this.getUser()?.firstName + ' ' + this.getUser()?.lastName;
  }

  get groups(): string[] {
    return this.getUser().groups ?? [];
  }
}
